import React from "react";

import type { ServerCmsContextProcessorsNavigationProcessor } from "@reactivated";

import { ReactivatedContext as Context } from "../../context";
import { Header } from "./Header";

export type HeaderContent = NonNullable<
    ServerCmsContextProcessorsNavigationProcessor["header_content"]
>;

interface Props {
    /** Override header data (used by snippet preview) */
    headerOverride?: HeaderContent;
    /** Whether the header renders transparently over the first body block */
    overlapNav?: boolean;
}

export const HeaderNav = ({ headerOverride, overlapNav }: Props) => {
    const context = React.useContext(Context);

    if (context.DESIGN_VERSION !== "v2026") return null;

    const headerContent = headerOverride ?? context.header_content;
    if (!headerContent) return null;

    return (
        <Header
            headerContent={headerContent}
            favoritesUrl={context.favorites_page_url}
            searchUrl={context.wagtail_links.search}
            overlapNav={overlapNav}
        />
    );
};
